/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./diamond.vue?vue&type=template&id=310de9a8&scoped=true"
import script from "./diamond.vue?vue&type=script&lang=js"
export * from "./diamond.vue?vue&type=script&lang=js"
import style0 from "./diamond.vue?vue&type=style&index=0&id=310de9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310de9a8",
  null
  
)

export default component.exports